import { Component } from '@angular/core';

@Component({
  selector: 'ap-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.css']
})
export class PageTitleComponent {

  constructor() {}

}
